import { render, staticRenderFns } from "./CaregiverLeaveLayout.vue?vue&type=template&id=2ece831d"
import script from "./CaregiverLeaveLayout.vue?vue&type=script&lang=js"
export * from "./CaregiverLeaveLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports